<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <router-link :to="{ path: '/admin/pick' }" class="big-btn red">
          Add Picks
        </router-link>
        <router-link :to="{ path: '/admin/picks' }" class="big-btn blue">
          Manage Picks
        </router-link>
        <router-link :to="{ path: '/admin/record' }" class="big-btn orange">
          Manage Record
        </router-link>
        <router-link :to="{ path: '/admin/testimonial' }" class="big-btn black">
          Add Testimonials
        </router-link>
        <router-link
          :to="{ path: '/admin/testimonials' }"
          class="big-btn black"
        >
          Manage Testimonials
        </router-link>
        <router-link :to="{ path: '/admin/posts/0' }" class="big-btn red">
          Add Blog Post
        </router-link>
        <router-link :to="{ path: '/admin/posts' }" class="big-btn green">
          Manage Blog Posts
        </router-link>
        <router-link :to="{ path: '/admin/users' }" class="big-btn blue">
          Manage Users
        </router-link>
        <router-link :to="{ path: '/admin/package' }" class="big-btn black">
          Manage Packages
        </router-link>
        <router-link :to="{ path: '/admin/categories' }" class="big-btn orange">
          Manage Categories
        </router-link>
        <button class="big-btn black" @click="clearCache()">
          Clear Cache
        </button>
      </div>
      <div v-if="admin" id="sidebar">
        <ul>
          <!-- widget START here -->
          <li class="widget">
            <div class="title">
              <h5>Members</h5>
            </div>
            <div class="content">
              <p>
                Overall: <b>{{ admin["overall"] }} members</b>
              </p>
              <p>
                Free: <b>{{ admin["free"] }} members<b> </b></b>
              </p>
              <p>
                All Sports: <b> {{ admin["all"] }} members</b>
              </p>
              <p>
                NFL: <b> {{ admin["nfl"] }} members</b>
              </p>
              <p>
                NCAAF: <b> {{ admin["ncaaf"] }} members</b>
              </p>
              <p>
                NBA: <b> {{ admin["nba"] }} members</b>
              </p>
              <p>
                NCAAB: <b> {{ admin["ncaab"] }} members</b>
              </p>
              <p>
                MLB: <b> {{ admin["mlb"] }} members</b>
              </p>
              <p>
                NHL: <b> {{ admin["nhl"] }} members</b>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import AdminRepository from "../data/admin.repository.js";
export default {
  data() {
    return {
      admin: {},
    };
  },
  created() {
    AdminRepository.get().then((data) => {
      this.admin = data;
    });
  },
  methods: {
    clearCache() {
      return AdminRepository.clearCache().then((result) => {
        this.$root.$refs.toastr.s("Cache emptied");
      });
    },
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// Admin.vue?9ea2a328